import React from "react";
import { useTranslation } from "react-i18next";
import { crystalliseSheet } from "../actions";
import { ActionMenu, ModalBuilder, Table } from "@redriver/cinnamon";
import { withRouter } from "react-router-dom";
import {
  withCurrentUser,
  PermissionCheck,
} from "features/../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { DropdownItem } from "semantic-ui-react";
import { ImpersonatedUserPermissionCheck } from "modules/ImpersonatedUserPermissions";

const CrystalliseSheet = ({ sheet, sheetActionRequired, onSubmitted }) => {
  const { t } = useTranslation("agreements");
  const {
    sheetId,
    sheetName,
    availableActionsIps,
    availableActionsPrincipal,
    isCrystallised,
  } = sheet;

  if (
    isCrystallised ||
    (process.env.TRADE_AS_IPS &&
      !sheet.availableActionsIps[sheetActionRequired]) ||
    (!process.env.TRADE_AS_IPS &&
      !sheet.availableActionsPrincipal[sheetActionRequired])
  ) {
    return null;
  }

  return (
    <ImpersonatedUserPermissionCheck
      target={Targets.Sheet}
      action={Actions.CrystalliseAndUncrystalliseSheets}
    >
      <ModalBuilder
        withForm
        submitAction={crystalliseSheet}
        submitParams={sheetId}
        onSubmitted={onSubmitted}
        renderTrigger={(trigger) => (
          <DropdownItem onClick={trigger}>
            {t("SheetActions.CrystalliseSheet.TriggerText")}
          </DropdownItem>
        )}
        renderModal={(modalProps) => (
          <TranslatedModal.Confirmation
            {...modalProps}
            header={t("SheetActions.CrystalliseSheet.HeaderText")}
            size="small"
          >
            {t("SheetActions.CrystalliseSheet.ConfirmMessage", { sheetName })}
          </TranslatedModal.Confirmation>
        )}
      />
    </ImpersonatedUserPermissionCheck>
  );
};

export default withCurrentUser(withRouter(CrystalliseSheet));
